import { Blackjacklogo } from '../ImageLoader';
import { Link } from "react-router";
const ExplorePremium = () => {

  return (<div id='ExplorePremium'>
          <img src={Blackjacklogo}></img>
          <h1 style={{'marginTop':'-10px'}}>What are premium bene<span style={{'letter-spacing':'3px'}}>f</span>its?</h1>
          <p>Premium bene<span style={{'letter-spacing':'1px'}}>f</span>its allow the player to experience every feature of the game.</p>
          <p>The bene<span style={{'letter-spacing':'1px'}}>f</span>its are as stated.</p>
          <ul>
            <li>Blackjack clubs</li>
            <li>Multi circle betting</li>
            <li>Infinite table AFK</li>
            <li>Mangified discard tray</li>
            <li>Access to lifetime career statistics</li>
            <a href="https://cwcreations.net/blog/2026/06/11/all-premium-benefits-on-c-w-blackjack/" ><li>See the extensive definition of bene<span style={{'letter-spacing':'1px'}}>f</span>its</li></a>
          </ul>
          
          <h1 style={{'display':'inline-block','marginTop':'4vh'}}>Who is premium for?</h1>
          <p>Premium is <u>both</u> for the person who enjoys the classic blackjack
           experience and for the person who wants to improve their play to prepare for real life gambling. For the person who plays blackjack only for entertainment will find value 
           in the infinite table AFK feature, in-game cosmetics and the ability to bet on multiple bet circles.</p>
          <p>Serious blackjack players, known in the blackjack communities as advantage players, will find value in premium by being able to create a game with any rules in blackjack clubs.
            Premium players can create custom games in blackjack clubs with any rules that would be found in real life casinos. Private games are also an option configurable in clubs.</p>
         </div>);
}


export default ExplorePremium;